import {DELETE_MANAGEMENT_START} from "../../types";

export const delete_management = (payload) => ({
    type: DELETE_MANAGEMENT_START,
    payload,
});
